'use strict';

import React from 'react';
import TS from '@zerolight/zlthunder-time-utils';

import Sparks from "./sparks";
import {getValue, formatValue} from "./shared";
import {cssClasses} from "../../shared/utils";

const MetricsTableColumns = [
	['Hour', 'h1'],
	['24 Hours', 'h24'],
	['7 Days', 'day7'],
	['30 Days', 'day30'],
	['Year', 'year'],
	['Lifetime', 'life']
];

function getIntervalValue(data, interval, getter) {
	if (!data) {
		return null;
	}
	let {tabs} = data;
	return getValue(tabs[interval], getter);
}

function MetricsTableTD({summary, getter, formatter}) {
	if (!summary) {
		return <td data-empty="Interval summary was not in the api response"/>;
	}
	if (summary.stale) {
		return <td className="stale" />;
	}
	let value = formatValue(summary, getter, formatter);
	if (value === null) {
		return <td data-empty="Value is null"/>;
	}
	return <td>{value}</td>
}

function MetricsTableTR({row, data}) {
	let [title, getter, formatter, rowData] = row;
	data = rowData || data;
	if (!(getter instanceof Function)) {
		let key = getter;
		getter = function (summary) {
			if (summary && summary.hasOwnProperty(key)) {
				return summary[key];
			}
			return null;
		};
	}

	if (!formatter) {
		formatter = v => String(v);
	}

	let sparksData = data.sparks;
	let sparks = null;
	if (sparksData) {
		let sparksSeries = [];
		for (let [k, s] of Object.entries(sparksData)) {
			let ts = TS.validate(Number(k) || k);
			let value = getter(s);
			sparksSeries.push({ts, value});
		}

		if (sparksSeries.length) {
			sparks = <Sparks series={sparksSeries} />;
		}
	}

	let tabsData = data.tabs;
	return <tr>
		<td>{title}</td>
		<td className="spark">{sparks}</td>
		{
			MetricsTableColumns.map(
				([__, interval]) => <MetricsTableTD
					key={interval} summary={tabsData[interval]}
					getter={getter} formatter={formatter} />
			)
		}
	</tr>
}

function MetricsTable({data, rows, className}) {
	return (
		<table className={cssClasses("metrics-table cm-table table table-stripped", className)}>
			<thead>
				<tr>
					<th>Metric</th>
					<th/>
					{MetricsTableColumns.map(([t, k]) => <th key={k}>{t}</th>)}
				</tr>
			</thead>
			<tbody>
				{rows.map((row, i) => <MetricsTableTR key={`mt-row-${i}`} data={data} row={row}/>)}
			</tbody>
		</table>
	);
}

export default MetricsTable;
export {
	MetricsTable, MetricsTableTR, MetricsTableTD,
	getValue, getIntervalValue, formatValue,
	MetricsTableColumns
};